import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { TableCell, TableRow, Checkbox } from '@mui/material';
import { Autocomplete, Typography } from '@totalsoft/rocket-ui';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';
import ColorPicker from 'components/common/inputs/ColorPicker';
import { get, set } from '@totalsoft/change-tracking-react';
import { onCheckBoxChange } from 'utils/propertyChangeAdapters';
import IconButton from 'components/common/buttons/IconButton';
import FlexBox from 'components/common/FlexBox';
import { FlowPermissionType, useFlowPermissions } from '../hooks';
import { usePermissions } from 'providers/RightsHooks';

const GenericEntityFlowEditStatesRow = ({ genericEntityBusinessStates, genericEntityFlowStateLens, index, onDelete, validation }) => {
  const [t] = useTranslation();

  const authorizationCode = useFlowPermissions(FlowPermissionType.WRITE);
  const canWrite = usePermissions(authorizationCode);

  return (
    <TableRow>
      <TableCell>
        <Autocomplete
          fullWidth
          label={t('GenericEntityFlow.State')}
          simpleValue={true}
          value={genericEntityFlowStateLens.stateId |> get}
          options={genericEntityBusinessStates}
          onChange={genericEntityFlowStateLens.stateId |> set}
          error={!(validation[index].stateId |> isValid)}
          helperText={validation[index].stateId |> getErrors}
          valueKey='stateId'
          labelKey='stateName'
          disabled={!canWrite}
        />
      </TableCell>
      <TableCell>
        <FlexBox justifyContent='center'>
          <ColorPicker
            color={genericEntityFlowStateLens.stateColor |> get}
            onChange={genericEntityFlowStateLens.stateColor |> set}
            disabled={!canWrite}
          />
        </FlexBox>
      </TableCell>
      <TableCell align='center'>
        <Checkbox
          checked={genericEntityFlowStateLens.isInitialState |> get}
          color='primary'
          onChange={genericEntityFlowStateLens.isInitialState |> set |> onCheckBoxChange}
          disabled={!canWrite}
        />
        {!(validation[index].isInitialState |> isValid) && (
          <Typography color={'error'}>{validation[index].isInitialState |> getErrors}</Typography>
        )}
      </TableCell>
      <TableCell align='center'>
        <Checkbox
          checked={genericEntityFlowStateLens.activeProduct |> get}
          color='primary'
          onChange={genericEntityFlowStateLens.activeProduct |> set |> onCheckBoxChange}
          disabled={!canWrite}
        />
      </TableCell>
      <TableCell align='center'>
        <Checkbox
          checked={genericEntityFlowStateLens.editableYN |> get}
          color='primary'
          onChange={genericEntityFlowStateLens.editableYN |> set |> onCheckBoxChange}
          disabled={!canWrite}
        />
      </TableCell>
      <TableCell align='center'>
        <Checkbox
          checked={genericEntityFlowStateLens.deletePermitted |> get}
          color='primary'
          onChange={genericEntityFlowStateLens.deletePermitted |> set |> onCheckBoxChange}
          disabled={!canWrite}
        />
      </TableCell>
      <TableCell align='right'>
        <IconButton type='delete' onClick={() => onDelete(index)} disabled={!canWrite} />
      </TableCell>
    </TableRow>
  );
};

GenericEntityFlowEditStatesRow.propTypes = {
  genericEntityBusinessStates: PropTypes.array.isRequired,
  genericEntityFlowStateLens: PropTypes.object,
  index: PropTypes.number,
  onDelete: PropTypes.func.isRequired,
  validation: PropTypes.object.isRequired
};

export default GenericEntityFlowEditStatesRow;
